import axios from 'axios';
import properties from '../../properties';

export interface CohortMembersCountResponse {
  noOfMemberIds: number;
  member_unique_ids: string[];
}
interface GetStopLossDiseaseCohortMembersParams {
  payload: any;
  max_claim_date: string;
}

export const getStopLossDiseaseCohortMembers = async ({
  payload,
  max_claim_date,
}: GetStopLossDiseaseCohortMembersParams): Promise<CohortMembersCountResponse> => {
  const baseUrl =
    properties.aiqBaseUrl +
    properties.stopLossBaseUrl +
    properties.getStopLossDiseaseCohortMembers;

  const requestBody = {
    ...payload,
    max_claim_date,
  };

  try {
    const res = await axios.post(baseUrl, requestBody);

    const data = res?.data?.data || {};

    return {
      member_unique_ids: data.member_unique_ids || [],
      noOfMemberIds: data.member_unique_ids?.length || 0,
    };
  } catch (error) {
    return {
      member_unique_ids: [],
      noOfMemberIds: 0,
    };
  }
};
